import { toast } from "@shared/hooks/use-toast";
import { Alert, AlertDescription } from "@shared/ui/alert";
import { AlertDialogHeader } from "@shared/ui/alert-dialog";
import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@shared/ui/dialog";
import { AlertCircle, AlertTriangle } from "lucide-react";
import React, { useState } from "react";

function AutoValidateDialog({
  isValidationDialogOpen,
  setIsValidationDialogOpen,
  onStartValidation,
}) {
  const [passReadingsDirectly, setPassReadingsDirectly] = useState(false);

  const handleStart = () => {
    onStartValidation(!passReadingsDirectly, {
      onSuccess: () => {
        setPassReadingsDirectly(false);
        setIsValidationDialogOpen(false);
      },
    });
  };

  return (
    // <div>AutoValidateDialog</div>
    <Dialog
      open={isValidationDialogOpen}
      onOpenChange={setIsValidationDialogOpen}
    >
      <DialogContent className="max-w-2xl max-h-[85vh] flex flex-col">
        <AlertDialogHeader className="flex-shrink-0">
          <DialogTitle className="text-xl font-semibold">
            Auto Validation Process
          </DialogTitle>
          <DialogDescription className="text-base mt-2">
            Configure how the system should handle meter reading validation
          </DialogDescription>
        </AlertDialogHeader>

        <div className="space-y-4 py-4 overflow-y-auto max-h-[420px] pr-2">
          <Alert className="border-blue-200 bg-blue-50">
            <AlertCircle className="h-5 w-5 text-blue-600" />
            <AlertDescription className="text-sm text-blue-800 ml-2">
              The system will run auto validation based on the validations
              configured in the meter cycle. If the readings auto validations
              are failed, they will be moved to the{" "}
              <strong>Exemption (V2)</strong> tab.
            </AlertDescription>
          </Alert>

          <div className="space-y-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <h4 className="font-semibold text-gray-900">Validation Options</h4>

            <div className="space-y-3">
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="validationOption"
                  checked={passReadingsDirectly}
                  onChange={() => setPassReadingsDirectly(true)}
                  className="mt-1"
                />
                <div>
                  <p className="font-medium text-gray-900">
                    Pass readings directly
                  </p>
                  <p className="text-sm text-gray-600">
                    All readings that pass auto-validation will be immediately
                    approved and moved forward in the billing process.
                  </p>
                </div>
              </label>

              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="validationOption"
                  checked={!passReadingsDirectly}
                  onChange={() => setPassReadingsDirectly(false)}
                  className="mt-1"
                />
                <div>
                  <p className="font-medium text-gray-900">
                    Keep for photo validation
                  </p>
                  <p className="text-sm text-gray-600">
                    Readings that pass auto-validation will remain in the
                    pending tab for manual photo validation with meter reading.
                  </p>
                </div>
              </label>
            </div>
          </div>

          <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <div className="flex items-start gap-2">
              <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-amber-800">
                <p className="font-semibold mb-1">Important Note</p>
                <p>
                  Failed validations will be automatically moved to the
                  Exemption (V2) tab for further review and manual processing.
                </p>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter className="flex-shrink-0 pt-2 border-t border-gray-100">
          <Button
            variant="outline"
            onClick={() => {
              setIsValidationDialogOpen(false);
              setPassReadingsDirectly(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className="bg-blue-600 hover:bg-blue-700"
            onClick={handleStart}
          >
            Start Validation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default AutoValidateDialog;
